import { Col, Row } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import KForm from 'app/components/Modules/Form/KForm'
import KInputNumber from 'app/components/Modules/Form/KInputNumber'
import KInputText from 'app/components/Modules/Form/KInputText'
import KMap from 'app/components/Modules/Form/KMap'
import { INames } from 'app/lib/hooks/useAddress'
import { useForceUpdate } from 'app/lib/hooks/useForceUpdate'
import { RecordTypeEnum } from 'app/queries'
import React, { ComponentProps } from 'react'

interface Props extends Partial<ComponentProps<typeof KForm>> {
  names?: INames
  initialValues?: Pick<IRental, 'longitude' | 'latitude'>
}

const DeliveryAddressMap: React.FC<Props> = ({ initialValues, names, ...others }) => {
  const forceUpdate = useForceUpdate()
  const { md } = useBreakpoint()

  return (
    <KForm
      initialFetch={false}
      silentSuccess={true}
      initialValues={initialValues}
      recordType={RecordTypeEnum.rentalDeliveryAddress}
      cancelable
      visualAction="confirm"
      portalId="modal-footer"
      layout="vertical"
      {...others}>
      <Row gutter={[16, 12]}>
        <Col xs={24} md={16}>
          <KMap
            options={{
              mapTypeControl: true
            }}
            height={md ? '600px' : '400px'}
            draggable
            names={names}
            fullAddressName="addressSummary"
          />
        </Col>
        <Col xs={24} md={8}>
          <Row gutter={[16, 12]}>
            <Col xs={12} md={24}>
              <KInputNumber min={-10} max={30} name="longitude" onBlur={forceUpdate} />
            </Col>
            <Col xs={12} md={24}>
              <KInputNumber max={70} min={35} name="latitude" onBlur={forceUpdate} />
            </Col>
            <Col span={24}>
              <KInputText name="addressSummary" readOnly />
            </Col>
          </Row>
        </Col>
      </Row>
      <KInputText name={names.address1} hidden />
      <KInputText name={names.address2} hidden />
      <KInputText name={names.zip} hidden />
      <KInputText name={names.city} hidden />
      <KInputText name={names.country} hidden />
    </KForm>
  )
}

export default DeliveryAddressMap
